// extracted by mini-css-extract-plugin
export var icon = "_69-1";
export var subtext = "_69-0";